<template>
  <div class="pos-absolute fill-height d-flex align-center" style="left: 0; top: 0;">
    <div class="pa-5 fs-24 font-weight-bold white--text line-height-tight transition-all">
      오늘 {{ nickname }}님과<br/> 함께하는 사람들의 <br/>마음날씨는
      <vue-typer
          :text="mindText"
          :shuffle="false"
          :repeat="0"
          initial-action="typing"
          :pre-type-delay="120"
          :type-delay="120"
          :pre-erase-delay="2500"
          :erase-delay="230"
          erase-style="clear"
          :erase-on-complete="false"
          caret-animation="blink"
      />
    </div>
  </div>
</template>

<script>
import store from '@/store'
import {mixinRemote} from '@/mixins'
export default {
  name: 'SquareHeader',
  mixins: [mixinRemote],
  props: ['mindCmpltYn', 'mindWeatherScore'],
  computed: {
    mindText () {
      let text = '........'
      if (this.mindWeatherText !== '........') return this.mindWeatherText
      if (this.mindWeatherScore !== null) {
        if (this.mindCmpltYn) {
          if (this.mindWeatherScore <= 1) {
            text = `매우 흐림이예요.`
          } else if (this.mindWeatherScore <= 3) {
            text = `흐림이예요.`
          } else if (this.mindWeatherScore <= 6) {
            text = `보통이예요.`
          } else if (this.mindWeatherScore <= 8) {
            text = `맑음이예요.`
          } else if (this.mindWeatherScore <= 10) {
            text = `쨍쨍이예요.`
          } else text = `보통이예요.`
          store.commit('setMindWeatherText', text)
        } else {
          text = `보통이예요.`
          store.commit('setMindWeatherText', text)
        }
      }
      return text
    }
  },
  created () {
    setTimeout(() => {
      if (this.mindText === '........') {
        this.$emit('setMindWeatherScore', 6)
      }
    }, 3000)
  },
  methods: {}
}
</script>
